import { useState } from 'react'
import Toggle from '../../components/Toggle'
import { ToggleOptions, CUSTOMER_SUPPORT, ENPHASE_INSTALLER } from './constants'
import { Box } from '@material-ui/core'
import UserSignIn from '../UserSignIn/index.js'
import { useStyles } from './styles.js'
const SignInBody = (props) => {
  const { setLoading } = props
  const [selectedToggle, setSelectedToggle] = useState(ENPHASE_INSTALLER)
  const classes = useStyles()
  return (
    <>
      <Toggle
        list={ToggleOptions}
        selected={selectedToggle}
        onChange={(id) => {
          setSelectedToggle(id)
        }}
      ></Toggle>
      <UserSignIn setLoading={setLoading}></UserSignIn>
    </>
  )
}
export default SignInBody
